import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=27857a7b&"
import script from "./ClientInfo.vue?vue&type=script&lang=js&"
export * from "./ClientInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports